<section>

  <h2 mat-dialog-title>{{data.title}}
    <span *ngIf="!fullBtn" class="right" (click)="openFull()">
      <mat-icon>fullscreen</mat-icon>
    </span>
    <span *ngIf="fullBtn" class="right" (click)="exitFull()">
      <mat-icon>fullscreen_exit</mat-icon>
    </span>
  </h2>
  <div class="alert">
    <alert-old-component #alertMessageMonitor></alert-old-component>
  </div>
  <div mat-dialog-content [ngClass]="{'default-height': !fullBtn, 'max-height': fullBtn}">
    <mat-accordion multi>
      <ng-container *ngFor="let dataSource of dataSourceArr; let i= index">

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="status-text-error" *ngIf="!!sendingMailList[i] && sendingMailList[i].length == 0">* Preview
                Mail {{i+1}}</span>
              <span *ngIf="!!sendingMailList[i] && sendingMailList[i].length > 0">Preview Mail {{i+1}}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <b>Subject:</b>
          <mat-form-field class="full-width" appearance="fill">
            <textarea matInput [(ngModel)]="htmlSubjectContent[i]"
              placeholder="Write your custom subject..."></textarea>
          </mat-form-field>

          <br />

          <b>Mail body:</b>
          <angular-editor [(ngModel)]="htmlContent[i]" [config]="htmlConfig.get(i)"></angular-editor>

          <br />

          <mat-list class="mat-list-custom">
            <mat-list-item class="mat-list-item-custom">
              <span> Notify To: </span>
            </mat-list-item>
            <mat-list-item class="mat-list-item-custom">
              <mat-form-field appearance="fill" class="new-mail-input">
                <mat-label>Contact Group</mat-label>
                <mat-select [(value)]="selectedFields[i]" (selectionChange)="checkSelects($event, i)">
                  <mat-option *ngFor=" let contactGroup of contactGroups" [value]="contactGroup">
                    {{contactGroup}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
          </mat-list>

          <!-- TO EMAIL -->
          <div class="mail-section">
            <div class="mail-to">
              <mat-list class="mat-list-custom">
                <mat-list-item class="mat-list-item-custom" *ngIf="!!sendingMailList[i] && sendingMailList[i].length == 0">
                  <span class="status-text-error">* Emails
                    To: (One email is
                    required)</span>
                </mat-list-item>
                <mat-list-item class="mat-list-item-custom" *ngIf="!!sendingMailList[i] && sendingMailList[i].length > 0">
                  <span >Emails To: </span>
                </mat-list-item>
                <mat-list-item class="mat-list-item-custom" *ngFor="let email of sendTo[i]">
                  <mat-icon class="delete-icon" (click)="deleteEmail(email, i, 'sendTo')">delete</mat-icon> {{email}}
                </mat-list-item>
                <mat-list-item class="mat-list-item-custom" *ngFor="let email of manualSendTo[i]">
                  <mat-icon class="delete-icon" (click)="deleteEmail(email, i, 'manualSendTo')">delete</mat-icon>
                  {{email}}
                </mat-list-item>

                <mat-list-item class="mat-list-item-custom">
                  <mat-form-field appearance="fill" class="new-mail-input">
                    <mat-label>New To Email</mat-label>
                    <input matInput [(ngModel)]='newMail' pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$">
                  </mat-form-field>
                  <button mat-stroked-button (click)="done(i)">
                    <mat-icon>person_add</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>

            <!-- CC EMAIL -->
            <div class="mail-cc">
              <mat-list class="mat-list-custom">
                <mat-list-item class="mat-list-item-custom">
                <span>Emails Cc: </span>
                </mat-list-item>
                <mat-list-item class="mat-list-item-custom" *ngFor="let email of sendCc[i]">
                  <mat-icon class="delete-icon" (click)="deleteEmail(email, i, 'sendCc')">delete</mat-icon> {{email}}
                </mat-list-item>
                <mat-list-item class="mat-list-item-custom" *ngFor="let email of manualSendCc[i]">
                  <mat-icon class="delete-icon" (click)="deleteEmail(email, i, 'manualSendCc')">delete</mat-icon>
                  {{email}}
                </mat-list-item>
                <mat-list-item class="mat-list-item-custom">
                  <mat-form-field appearance="fill" class="new-mail-input">
                    <mat-label>New Cc Email</mat-label>
                    <input matInput [(ngModel)]='newMailCc' pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$">
                  </mat-form-field>
                  <button mat-stroked-button (click)="done(i, true)">
                    <mat-icon>person_add</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
          <div class="attachment-section">
            <div class="attachment-list">
              <mat-list>
                <span>Your attachments: </span>
                <mat-list-item *ngFor="let attachment of sendAttachment[i]">
                  <mat-icon mat-list-icon class="delete-file-icon"
                    (click)="deleteEmail(attachment.name, i, 'sendAttachment')" matTooltip="Remove file from list"
                    matTooltipClass="tooltip-red">
                    link_off</mat-icon>
                  <div mat-line>{{attachment.name}}</div>
                  <div mat-line> {{ formatBytes(attachment.size) }} </div>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
          <br />
          <button mat-stroked-button (click)="attachFile(i)">
            <mat-icon>attach_file</mat-icon>
          </button>
          <button mat-raised-button style="color: white" (click)="sendNotify(i)"
            class="right">{{data.confirmButtonLabel | translate}}</button>
        </mat-expansion-panel>

        <br />
      </ng-container>
    </mat-accordion>

  </div>

  <div class="spacer"></div>

  <div mat-dialog-actions align="end" mat-elevation-z8>
    <button mat-button [mat-dialog-close]="false">{{data.closeButtonLabel | translate}}</button>

  </div>
</section>
